<template>

    <div class="order-system-activities">

        <b-modal :active.sync="modalComment.active" has-modal-card>
            <comment-modal
              :save-callback="createComment"
              :vetted-note-fetch-params="{ firm_id: order.created_by_firm_id }"
              @create="onCommentModalCreate"
            />
        </b-modal>

        <b-modal :active.sync="vet_comment_modal_active" has-modal-card trap-focus>
            <vetting-comment-modal :target="commentBeingVetted" @comment-saved="refreshComments"></vetting-comment-modal>
        </b-modal>

        <div class="card">
            <div class="card-content">

                <div class="block">
                    <b-checkbox v-model="activitiesFilter" native-value="comments">Comments</b-checkbox>
                    <b-checkbox v-model="activitiesFilter" native-value="logs">Logs</b-checkbox>
                    <b-checkbox v-model="activitiesFilter" native-value="notifications">Notifications</b-checkbox>
                    <b-checkbox v-model="activitiesFilter" native-value="system">System</b-checkbox>
                </div>

                <b-button id="add_order_comment" @click="() => modalComment.active = true" :disabled="!order.editable">Add Comment</b-button>

            </div>
        </div>

        <div class="table-wrapper b-table">
            <table class="table">
                <tr>
                    <th>Date</th>
                    <th>Creator</th>
                    <th style="padding-left:50px;">Details</th>
                </tr>
                <tr v-for="(row, key) in sortedActivities">
                    <td class="is-narrow">{{ row.ui.created_at_formatted }}</td>
                    <td>
                        <div style="font-size:15px; margin-left:18px;">
                            <b-tooltip :label="row.createdBy.firstName" position="is-right">
                                <i class="fa fa-user"></i>
                            </b-tooltip>
                        </div>
                    </td>
                    <td>
                        <div style="display:flex;">
                            <div style="margin-right:20px;">
                                <b-tooltip class="row-info" :label="'[' + row.model + '] ' + ' - ' + row.type + ' - ' + row.subtype" position="is-right">
                                    <span class="fa fa-info-circle" style="font-size:15px;"></span>
                                </b-tooltip>
                            </div>
                            <div style="display: -webkit-box; -webkit-box-orient: vertical; overflow:hidden;">
                                <span v-if="row.ui.can_be_vetted && canVetNotes">
                                    <button type="button" class="button is-small" @click="onVetNoteIntent(row.id)">REVIEW</button>
                                </span>
                                <ul v-if="row.notifiableType && row.data">
                                    <li v-for="(data, index) in row.data" :key="index">
                                        <span v-if="index == 'to'">to : {{ data[0].email }}</span>
                                        <span v-else-if="index == 'merge_vars' || index == 'merge_language'"></span>
                                        <span v-else>{{ index }} : {{ data }}</span>
                                    </li>
                                </ul>
                                <span>{{ row.content || row.message }}</span>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        </div>

        <!-- <div class="table-container">
            <b-table :data="sortedActivities" :columns="$options.columns" :loading="loading" :can-vet-notes="canVetNotes" :on-vet-note-intent="onVetNoteIntent">
                <template slot-scope="props">
                    <b-table-column
                        :field="column.field"
                        :label="column.label"
                        :width="column.width || ''"
                        :style="`${column.meta && column.meta.expanded ? 'width: 100%; max-width: 0' : 'width:' + column.meta.width}`"
                        v-for="column in $options.columns"
                        :key="column.field"
                    >
                        <template v-if="column.meta && column.meta.rowSlot">
                            <span v-if="column.meta.rowSlot === 'rowDate'">{{ props.row.ui.created_at_formatted }}</span>
                            <span v-if="column.meta.rowSlot == 'rowSubtype'">
                                <b-tooltip :label="props.row.subtype" position="is-right">
                                    <span class="fa fa-info-circle"></span>
                                </b-tooltip>
                                <span v-if="props.row.ui.can_be_vetted && canVetNotes">
                                    <button type="button" class="button is-text is-small" @click="onVetNoteIntent(props.row.id)">VET</button>
                                </span>
                            </span>
                            <div v-if="column.meta.rowSlot === 'rowCreator' && props.row.createdBy" style="font-size:15px; margin-left:18px;">
                              <b-tooltip :label="props.row.createdBy.firstName + ' ' + props.row.createdBy.lastName" position="is-right">
                                <i class="fa fa-user"></i>
                              </b-tooltip>
                            </div>
                            <span v-if="column.meta.rowSlot === 'rowInfo'">
                                <b-tooltip class="row-info" :label="'[' + props.row.model + '] ' + ' - ' + props.row.type + ' - ' + props.row.subtype" position="is-right">
                                    <span class="fa fa-info-circle" style="font-size:15px;"></span>
                                </b-tooltip>
                            </span>
                            <div v-if="column.meta.rowSlot === 'rowComment'" style="display: -webkit-box; -webkit-box-orient: vertical; overflow:hidden;">
                                <span v-if="props.row.ui.can_be_vetted && canVetNotes">
                                    <button type="button" class="button is-small" @click="onVetNoteIntent(props.row.id)">REVIEW</button>
                                </span>

                                <ul v-if="props.row.notifiableType && props.row.data">
                                    <li v-for="(data, index) in props.row.data" :key="index">
                                        <span v-if="index == 'to'">to : {{ data[0].email }}</span>
                                        <span v-else-if="index == 'merge_vars' || index == 'merge_language'"></span>
                                        <span v-else>{{ index }} : {{ data }}</span>
                                    </li>
                                </ul>
                                <span>{{ props.row.content || props.row.message }}</span>
                            </div>
                        </template>
                        <template v-else>{{ props.row[column.field] }}</template>
                    </b-table-column>
                </template>
                <template slot="empty">No notes or activity.</template>
            </b-table>
        </div> -->

    </div>

</template>

<script>

    import CommentModal from "@/components/Comment/CommentModal";
    import VettingCommentModal from "@/components/Comment/VettingCommentModal";
    import { OrderService } from "@/services/order.service";
    import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
    import { DateFormat } from "@/helpers/date-format";
    import moment from "moment";

    export default {

      orderService: OrderService,
      columns: [
        {
          field: "date",
          label: "Date",
          meta: {
            rowSlot: "rowDate",
            width: '20%',
          }
        },
        // {
        //   field: "subtype",
        //   label: "Type",
        //   meta: {
        //     rowSlot: 'rowSubtype'
        //   }
        // },
        {
          field: "creator",
          label: "Creator",
          meta: {
            rowSlot: "rowCreator",
            width: '15%',
          }
        },
        {
        field: "info",
          label: "",
          meta: { 
            rowSlot: "rowInfo",
            width: '10px',

          }
        },
        {
          field: "content",
          label: "Details",
          meta: {
            rowSlot: "rowComment",
            expanded: true
          }
        }
      ],
      props: {
        order: {
          type: Object,
          required: true
        }
      },
      components: {
        CommentModal,
        VettingCommentModal
      },
      data: () => ({
        modalComment: {
          active: false
        },
        activities: [],
        comments: [],
        logs: [],
        notifications: [],
        activitiesFilter: [],
        loading: false,
        commentsLoaded: false,
        logsLoaded: false,
        notificationsLoaded: false,
        vet_comment_id: null,
        vet_comment_modal_active: false,
      }),
      created() {
        this.activitiesFilter= ['comments'];
      },
      watch: {
        activities(activities) {
          this.$emit("update:activities", activities);
        },
        async activitiesFilter(filter){
          if(filter.length == 0){
              this.activities = []
          }else {
            this.loading = true
            this.activities = []

            // Comments
            if(filter.includes('comments')){

              if(!this.commentsLoaded){
                this.comments = await this.fetchComments()
              }

              this.activities = this.activities.concat(this.comments)
            }

            // Logs
            if(filter.includes('logs')){
              if(!this.logsLoaded){
                this.logs = await this.fetchLogs()
              }

              const logs = this.logs.filter(log => {
                return !log.subtype || log.subtype.toLowerCase().indexOf('system') < 0;
              });
              this.activities = this.activities.concat(logs)
            }

            // Logs System
            if(filter.includes('system')) {

              if(!this.logsLoaded){
                this.logs = await this.fetchLogs()
              }

              const logs = this.logs.filter(log => {
                return log.subtype && log.subtype.toLowerCase().indexOf('system') === 0;
              });
              this.activities = this.activities.concat(logs)
            }

            if(filter.includes('notifications')) {

              if(!this.notificationsLoaded){
                this.notifications = await this.fetchNotifications()
              }

              this.activities = this.activities.concat(this.notifications)
            }

            this.loading = false

          }
        }
      },
      computed: {
        user() {
          return this.$store.state.Auth.user;
        },
        preparedActivities() {
          let prepared = [].concat(this.activities);

          prepared = prepared.reduce((acc, item) => {
            item.ui = {
              can_be_vetted:
                item.commentableType &&
                item.commentableType.slice(-5) == "Order" &&
                item.subtype.toUpperCase() == "PENDING_APPROVAL"
                  ? true
                  : false,
              created_at_formatted: DateFormat.toLocalDateAndTime(item.createdAt)
            };

            if (item.ui.can_be_vetted && this.user.firm.id !== this.order.firm.id) {
              return acc;
            }

            acc.push(item);

            return acc;
          }, []);

          return prepared;
        },
        sortedActivities() {
          return this.preparedActivities.sort((a,b) => {
            const a_val = moment(a.createdAt).format('X'); // where "X" means unix timestamp
            const b_val = moment(b.createdAt).format('X');
            if (a_val < b_val) return 1;
            if (a_val > b_val) return -1;
            if (a_val == b_val) {
              if (a.commentableType && b.commentableType) {
                // these are both comments, sort by ID.
                return this.sortNumbers(a.id, b.id);
              }
              if (a.loggableType && b.loggableType) {
                // these are both logs, sort by ID.
                return this.sortNumbers(a.id, b.id);
              }
              if (a.loggableType && !b.loggableType) {
                // Logs usually happen first
                return 1;
              }
            }
            // Last resort equal
            return 0;
          });
        },
        canVetNotes() {
          return this.$store.getters['Auth/hasPermission']('can vet notes');
        },
        commentBeingVetted() {
          let comment = null;
          if (this.vet_comment_id) {
            comment = this.activities.find(item => {
              return item.id == this.vet_comment_id;
            });
          }
          return comment;
        }
      },
      methods: {
        fetchComments(){
          this.commentsLoaded = true
          return this.$options.orderService
                .listComments(this.order.id, {includes: 'createdBy'})
                .then(response => JsonDenormalizer.denormalize(response.data));

        },
        fetchLogs(){
          this.logsLoaded = true
          return this.$options.orderService
                .listLogs(this.order.id, {includes: 'createdBy'})
                .then(response => JsonDenormalizer.denormalize(response.data));
        },
        fetchNotifications(){
          this.notificationsLoaded = true
          return this.$options.orderService
                .listNotifications(this.order.id, {includes: 'createdBy'})
                .then(response => JsonDenormalizer.denormalize(response.data));
        },
        async createComment(data) {
          await this.$options.orderService.createComment(this.order.id, {
            vetted_order_activity_id: data.vetted_order_activity_id,
            comment: data.description,
            subtype: data.subtype,
            is_sensitive: data.confidential
          });
        },
        async refreshComments() {
          // We need to replace comments in this.activities with
          // a fresh fetch from server (new comment just added)
          await this.fetchComments()
            .then(comments => {
              this.comments = comments;
              let activities = this.activities.filter(item => {
                return ( ! item.commentableType);
              });
              this.activities = activities.concat(comments);
              return Promise.resolve(comments);
            });
        },
        onCommentModalCreate() {
          this.refreshComments();
        },
        sortNumbers(a, b) {
          return a < b
            ? 1
            : (a > b) ? -1 : 0;
        },
        onVetNoteIntent(id) {
          this.vet_comment_id = id;
          this.vet_comment_modal_active = true;
        }
      }

    };

</script>


// WEBPACK FOOTER //
// src/components/Order/OrderSystemActivities.vue